import { IApplicationState } from '@store'

export const selectHasFetchedAdAccounts = (state: IApplicationState) => state.facebookAds.hasFetched
